import { lazy } from "react";
import { Activity } from "lucide-react";
import type { AdminModule } from "../types";

const Dashboard = lazy(() => import("./pages/Dashboard").then((m) => ({ default: m.Dashboard })));
const Queues = lazy(() => import("./pages/Queues").then((m) => ({ default: m.Queues })));
const Logs = lazy(() => import("./pages/Logs").then((m) => ({ default: m.Logs })));

export const serverModule: AdminModule = {
  key: "server",
  label: "Server",
  description: "CloudWatch metrics, deep health, SQS queues and DLQ replay.",
  group: "operations",
  icon: Activity,
  requiredPermission: "admin.server.metrics.read",
  routes: [
    { path: "dashboard", label: "Dashboard", element: <Dashboard /> },
    { path: "queues", label: "Queues", element: <Queues /> },
    { path: "logs", label: "Logs", element: <Logs /> },
  ],
};
